import React from "react";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import { useParams } from "react-router-dom";

import LoadingInput from "../../../../_components/LoadingInput";
import Address from "../../../../_components/Address";
import { toast } from "react-toastify";
import { useChange, useGetData } from "./hooks";
import { createClient, getClient, updateClient } from "../../../../api/clients";

export default (props) => {
  const ref = React.useRef(null);
  const params = useParams();
  const [state, handleChange] = useChange({ type: 1, address: {} });
  const [address, setAddress] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const onSave = async () => {
    document.querySelectorAll("input").forEach((input) => {
      input.classList.remove("is-invalid");
    });
    let errors = [];

    const payload = useGetData(state);

    const addressFields = [
      { name: "postal_code", validator: (value) => !!value },
      { name: "state_location", validator: (value) => !!value },
      { name: "city_location", validator: (value) => !!value },
      { name: "district", validator: (value) => !!value },
      { name: "street", validator: (value) => !!value },
      { name: "street", validator: (value) => !!value },
    ];

    addressFields.forEach(({ name, validator }) => {
      if (!validator(address[name])) {
        console.debug(name);
        errors.push(name);
        try {
          document
            .querySelector(`input[name="${name}"], select[name="${name}"]`)
            .classList.add("is-invalid");
        } catch (error) {
          console.error(
            `Erro ao adicionar classe inválida para ${name}:`,
            error
          );
        }
      } else {
        try {
          document
            .querySelector(`input[name="${name}"], select[name="${name}"]`)
            .classList.remove("is-invalid");
        } catch (error) {
          console.error(
            `Erro ao adicionar classe inválida para ${name}:`,
            error
          );
        }
      }
    });

    if (errors.length > 0) {
      toast.error("Preencha os campos corretamente", {
        position: "top-center",
        autoClose: 5000,
        toastId: "error-create-cliente-without-address",
      });
      return;
    }

    payload["address"] = address;

    const request = params.id
      ? updateClient(params.id, payload)
      : createClient(payload);

    setLoading(true);
    request
      .then((_) => {
        toast.success(
          <Text color="white" align="center">
            Cliente salvo
          </Text>,
          {
            position: "top-center",
            autoClose: 5000,
            toastId: "success-create-cliente",
          }
        );
        setTimeout(() => {
          window.location.href = "/clients";
        }, 3000);
      })
      .catch((error) => {
        if (error.non_field_errors) {
          if (error.non_field_errors[0] === "CPF Already registred") {
            toast.error(
              <Text color="white" align="center">
                CPF Já está cadastrado
              </Text>,
              {
                position: "top-center",
                toastId: "error-CPF-Already-registred",
              }
            );
            return;
          } else if (error.non_field_errors[0] === "CNPJ Already registred") {
            toast.error(
              <Text color="white" align="center">
                CNPJ Já está cadastrado
              </Text>,
              {
                position: "top-center",
                toastId: "error-CNPJ-Already-registred",
              }
            );
          }
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 3000);
      });
  };

  const onChangeAddress = (addr) => {
    setAddress(addr);
  };

  React.useEffect(() => {
    if (params.id) {
      setLoading(true);
      getClient(params.id)
        .then((resp) => {
          if (resp.company) {
            handleChange.forceUpdate({
              type: 2,
              company_name: resp.name,
              company_email: resp.email,
              company_phone_number: resp.phone_number,
              fancy_name: resp.company.fancy_name,
              cnpj: resp.company.cnpj,
              company_state_registry: resp.company.state_registry,
              address: {},
            });
          } else {
            handleChange.forceUpdate({
              type: resp.individual.state_registry ? 3 : 1,
              name: resp.name,
              email: resp.email,
              phone_number: resp.phone_number,
              cpf: resp.individual.cpf,
              address: {},
              state_registry: resp.individual.state_registry
                ? resp.individual.state_registry
                : "",
            });
          }
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(!true);
          }, 2000);
        });
    }
  }, [ref.current]);

  return (
    <div className="container-fluid" ref={ref}>
      <div className="row">
        <div className="col-12 py-4">
          <Text className="lead">Cadastar novo Cliente</Text>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 col-xl-4 col-12">
          <LoadingInput
            label="Selecione o tipo de cliente: "
            name="type"
            onChange={handleChange}
            disabled={loading || params.id}
            as="select"
          >
            <option value="" disabled selected>
              Selecione
            </option>
            <option selected={state.type == 1} value="1">
              Pessoa Física
            </option>
            <option selected={state.type == 2} value="2">
              Pessoa Jurídica
            </option>
            <option selected={state.type == 3} value="3">
              Produtor Rural
            </option>
          </LoadingInput>
        </div>
      </div>
      <div
        className={`${state.type == 1 || state.type == 3 ? "row" : "d-none"}`}
      >
        <div className="col-md-4 col-xl-4 col-12">
          <LoadingInput
            disabled={loading}
            maxLength={100}
            label="Nome: "
            onChange={handleChange}
            name="name"
            value={state.name}
            type="text"
            placeholder="Informe o nome do cliente"
          />
        </div>
        <div className="col-md-4 col-xl-4 col-12">
          <Text>Informe o CPF: </Text>
          <LoadingInput
            disabled={loading}
            onChange={handleChange}
            type="cpf"
            name="cpf"
            value={state.cpf}
          />
        </div>
        <div
          className={`${
            state.type == 3 ? "col-md-4 col-xl-4 col-12" : "d-none"
          }`}
        >
          <Text>Inscrição Estadual (IE)</Text>
          <LoadingInput
            disabled={loading}
            onChange={handleChange}
            type="text"
            maxLength={20}
            value={state.state_registry}
            name="state_registry"
          />
          <Button
            onClick={() => {
              window.open(
                "https://dfe-portal.svrs.rs.gov.br/NFE/CCC",
                "__blank"
              );
            }}
            as="text"
          >
            Não sei a Inscrição Estadual
          </Button>
        </div>
        <div className="col-md-4 col-xl-4 col-12">
          <Text>Email</Text>
          <LoadingInput
            disabled={loading}
            maxLength={100}
            onChange={handleChange}
            name="email"
            type="email"
            value={state.email}
          />
        </div>
        <div className="col-md-4 col-xl-4 col-12">
          <Text>Telefone: </Text>
          <LoadingInput
            disabled={loading}
            onChange={handleChange}
            name="phone_number"
            type="phone_number"
            value={state.phone_number}
          />
        </div>
      </div>
      <div className={`${state.type == 2 ? "row" : "d-none"}`}>
        <div className="col-md-3 col-xl-3 col-12">
          <LoadingInput
            label="Informe o CNPJ:"
            disabled={loading}
            value={state.cnpj}
            onChange={handleChange}
            type="cnpj"
            name="cnpj"
          />
        </div>
        <div className="col-md-3 col-xl-3 col-12">
          <LoadingInput
            label="Informe a Razão Social:"
            disabled={loading}
            onChange={handleChange}
            type="text"
            value={state.company_name}
            name="company_name"
          />
        </div>
        <div className="col-md-3 col-xl-3 col-12">
          <LoadingInput
            label="Informe o nome fantasia:"
            disabled={loading}
            onChange={handleChange}
            type="text"
            value={state.fancy_name}
            name="fancy_name"
          />
        </div>
        <div className="col-md-3 col-xl-3 col-12">
          <LoadingInput
            label="Inscrição Estadual (IE)"
            disabled={loading}
            onChange={handleChange}
            type="text"
            maxLength={20}
            value={state.company_state_registry}
            name="company_state_registry"
          />
          <Button
            onClick={() => {
              window.open(
                "https://dfe-portal.svrs.rs.gov.br/NFE/CCC",
                "__blank"
              );
            }}
            as="text"
          >
            Não sei a Inscrição Estadual
          </Button>
        </div>
        <div className="col-md-3 col-xl-3 col-12">
          <Text>Email: </Text>
          <LoadingInput
            disabled={loading}
            onChange={handleChange}
            name="company_email"
            value={state.company_email}
            type="email"
          />
        </div>
        <div className="col-md-3 col-xl-3 col-12">
          <Text>Telefone: </Text>
          <LoadingInput
            disabled={loading}
            onChange={handleChange}
            value={state.company_phone_number}
            name="company_phone_number"
            type="phone_number"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 py-4">
          <Address disabled={loading} onChange={onChangeAddress} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <Button disabled={loading} onClick={onSave}>
              Salvar
            </Button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <Button
              disabled={loading}
              className="mt-5 text-danger"
              as="text"
              color="secondary"
              onClick={() => {
                window.location.href = "/clients";
              }}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/Client/index.jsx